<template>
  <div class="bank-form">
    <form method="POST" :action="$props.formData.action" :target="targetSubmit">
      <template v-if="$props.formData && $props.formData.parameters && $props.formData.parameters.length">
        <input v-for="(param, index) in $props.formData.parameters"
               :key="'param'+index"
               type="hidden"
               :name="param.key"
               :value="param.value"/>
        <button type="submit" ref="submitButton">&nbsp;</button>
      </template>
    </form>
  </div>
</template>

<script>
export default {
  name: 'bank-form',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      },
      required: true
    },
    newWindow: Boolean
  },
  computed: {
    targetSubmit () {
      if (this.$props.newWindow) return '_blank'
      return '_self'
    }
  },
  methods: {
    submitForm () {
      this.$refs.submitButton.click()
    }
  }
}
</script>

<style scoped lang="scss">
.bank-form {
  position: fixed;
  left: -99999px;
  z-index: -1;
}
</style>
